// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.city-list {
	position: relative;
	width: 97%;
	height: 100px;
	color: var(--primary-color1);
	background-color: white;
	/* border: 1px solid black; */
	display: flex;
	align-items: center;
	flex-direction: column;
	overflow: scroll;
	border-radius: 0.7rem;
	padding-bottom: 0px;
	box-shadow: 0px 0px 8px -2px black;
}

.city-list::-webkit-scrollbar {
	width: 0.3rem;
}
.city-list-item {
	width: 95%;
	text-align: center;
	line-height: 1.5rem;
	font-size: 1.2rem;
	padding: 0.5rem 0.5rem;
}
.city-list-item:hover {
	background-color: var(--secondary-color2);
}

.search-bar-master-container {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.search-bar-container {
	position: relative;
	display: flex;
	justify-content: center;
	width: 100%;
	padding: 0.5rem 0.1rem 0.5rem 0.1rem;
	overflow: hidden;
}

.search-bar-container input {
	width: 100%;
	border-radius: 0.5rem;
	line-height: 2.5rem;
	font-size: 1.6rem;
	/* margin: 1rem; */
	text-align: center;
	animation: slide-left 0.2s ease-in-out;
	background-color: white;
	color: var(--primary-color1);
	border: 2px solid var(--www-color-float-bg2);
}

.search-bar-container.off input {
	text-align: center;
	/* animation: slide-left 0.5s ease-in-out reverse; */
	background-color: white;
	color: var(--primary-color1);
	border: 2px solid var(--www-color-float-bg2);
	transition: opacity 300ms, transform 300ms;
	visibility: hidden;
}

.form-container {
	width: 100%;
}

@media (min-width: 500px) {
	.search-bar-container input {
		border: none;
		text-align: center;
		animation: slide-left 0.2s ease-in-out;
		background-color: white;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/LeftPanel/MapWithDate/MyMap/SearchLocationIcon/LiveSearchCaps/LiveSearchCaps.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,UAAU;CACV,aAAa;CACb,4BAA4B;CAC5B,uBAAuB;CACvB,6BAA6B;CAC7B,aAAa;CACb,mBAAmB;CACnB,sBAAsB;CACtB,gBAAgB;CAChB,qBAAqB;CACrB,mBAAmB;CACnB,kCAAkC;AACnC;;AAEA;CACC,aAAa;AACd;AACA;CACC,UAAU;CACV,kBAAkB;CAClB,mBAAmB;CACnB,iBAAiB;CACjB,sBAAsB;AACvB;AACA;CACC,yCAAyC;AAC1C;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,uBAAuB;CACvB,WAAW;CACX,oCAAoC;CACpC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB,mBAAmB;CACnB,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,sCAAsC;CACtC,uBAAuB;CACvB,4BAA4B;CAC5B,4CAA4C;AAC7C;;AAEA;CACC,kBAAkB;CAClB,oDAAoD;CACpD,uBAAuB;CACvB,4BAA4B;CAC5B,4CAA4C;CAC5C,0CAA0C;CAC1C,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC;EACC,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,uBAAuB;CACxB;AACD","sourcesContent":[".city-list {\n\tposition: relative;\n\twidth: 97%;\n\theight: 100px;\n\tcolor: var(--primary-color1);\n\tbackground-color: white;\n\t/* border: 1px solid black; */\n\tdisplay: flex;\n\talign-items: center;\n\tflex-direction: column;\n\toverflow: scroll;\n\tborder-radius: 0.7rem;\n\tpadding-bottom: 0px;\n\tbox-shadow: 0px 0px 8px -2px black;\n}\n\n.city-list::-webkit-scrollbar {\n\twidth: 0.3rem;\n}\n.city-list-item {\n\twidth: 95%;\n\ttext-align: center;\n\tline-height: 1.5rem;\n\tfont-size: 1.2rem;\n\tpadding: 0.5rem 0.5rem;\n}\n.city-list-item:hover {\n\tbackground-color: var(--secondary-color2);\n}\n\n.search-bar-master-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\n.search-bar-container {\n\tposition: relative;\n\tdisplay: flex;\n\tjustify-content: center;\n\twidth: 100%;\n\tpadding: 0.5rem 0.1rem 0.5rem 0.1rem;\n\toverflow: hidden;\n}\n\n.search-bar-container input {\n\twidth: 100%;\n\tborder-radius: 0.5rem;\n\tline-height: 2.5rem;\n\tfont-size: 1.6rem;\n\t/* margin: 1rem; */\n\ttext-align: center;\n\tanimation: slide-left 0.2s ease-in-out;\n\tbackground-color: white;\n\tcolor: var(--primary-color1);\n\tborder: 2px solid var(--www-color-float-bg2);\n}\n\n.search-bar-container.off input {\n\ttext-align: center;\n\t/* animation: slide-left 0.5s ease-in-out reverse; */\n\tbackground-color: white;\n\tcolor: var(--primary-color1);\n\tborder: 2px solid var(--www-color-float-bg2);\n\ttransition: opacity 300ms, transform 300ms;\n\tvisibility: hidden;\n}\n\n.form-container {\n\twidth: 100%;\n}\n\n@media (min-width: 500px) {\n\t.search-bar-container input {\n\t\tborder: none;\n\t\ttext-align: center;\n\t\tanimation: slide-left 0.2s ease-in-out;\n\t\tbackground-color: white;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
